import { Component, Input, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'mini-loading',
    templateUrl: 'mini-loading.html',
    styleUrls: ['./loading.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default
})
export class MiniLoadingComponent {
    @Input() loadingText: string = '';
    @Input() loading: boolean = true;
    @Input() spinAnimation: boolean = true;
    @Input() colorAnimation: boolean = false;
}
